// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__29nrg","productName":"Table_productName__2OVLX"};